/*********************************************************/
/*This file contains functions called to
/*create backlogs. The calls for these can be found in
/*TabSwitcher.js for "chains" otherwise known as garland 
/*or light drawings on the tree, place items can be found
/*being called in InputEvents (Decor, Ornaments,
/* and gifts). Backlogs for swap actions are found in
/*Tabs/TrayItemsClicked TreeTop and Tree click handlers
/* BackLogs are actioned on by 
/*onUndoButtonClicked in folder ButtonClickHandlers
/*********************************************************/

import { Game } from "phaser";

export function CreatePlacedItemBackLog(GameObject,Operation,OperationData)
{
    
    const Scene = GameObject.scene;
    
    switch(Operation)
    {
        case 'Created':
            _createdEntry(Scene,GameObject);
            break;
        case 'Moved':
            _movedEntry(Scene,GameObject,OperationData);
            break;
        case 'Destroyed':
            break;
        case 'Swapped':
            _swappedEntry(Scene,GameObject,OperationData);
            break;
        default:
            //console.log(Operation);
            break;
    }
}

function _createdEntry(Scene,GameObject)
{
    //if(GameObject)
    const AssetType = GameObject.getData('AssetType');
    Scene.OnTreeGroup.add(GameObject);
    Scene.BackLog.push({Operation: "Created",AssetType: AssetType,GameObject: GameObject});
}

function _movedEntry(Scene,GameObject,OperationData)
{
    const AssetType = GameObject.getData('AssetType');
    Scene.BackLog.push({Operation: "Moved",AssetType: AssetType,GameObject: GameObject,Data: {x: OperationData.x,y: OperationData.y}});
}

function _swappedEntry(Scene,GameObject,OperationData)
{
    const AssetType = GameObject.getData('AssetType');
    Scene.BackLog.push({Operation: "Swapped",AssetType: AssetType,GameObject: GameObject,OperationData});
}

export function CreateDrawnBackLog(GameObject,Operation,OperationData)
{
    const Scene = GameObject[0].scene;

    switch(Operation)
    {
        case 'Created':
            _createdDrawnEntry(Scene,GameObject);
            break;
        case 'Moved':
            _movedDrawnEntry(Scene,GameObject,OperationData);
            break;
        case 'Destroyed':
            break;
        default:
            break;
    }
}

function _createdDrawnEntry(Scene, GameObject)//In this case, game object could be an array 
{                                             //Even a single light is a bulb and the glow asset
                                              //But garlands are single assets
    Scene.OnTreeGroup.addMultiple(GameObject);
    //console.log(Scene.OnTreeGroup);
    Scene.BackLog.push({Operation: "Created",AssetType: 'Chain',GameObject: GameObject});
}

export function RemoveFromBackLog(Scene,GameObject)
{
    //console.log("in");
    Scene.BackLog = Scene.BackLog.filter((value)=>
    {
        return value.GameObject != GameObject;
    })
}